// extracted by mini-css-extract-plugin
export default {"root":"NoImage-module-root","title":"NoImage-module-title","description":"NoImage-module-description"};